import {style, keyframes} from 'typestyle'
import * as csstips from 'csstips'

export const container = style({
    padding: 15
})

export const list = style({
    borderRadius: 10,
    overflow: 'hidden',
    boxSizing: 'border-box',
    backgroundColor: '#fff'
})

export const listItem = style({
    display: 'flex',
    cursor: 'pointer',
    ...csstips.flexRoot,
    ...csstips.content,
    ...csstips.start,
    margin: '0 15px',
    padding: '15px 0',
    boxSizing: 'border-box',
    borderBottom: '1px solid #eee',
    $nest: {
        '&:last-child': {
            borderBottom: 'none'
        }
    }
})

export const leftSide = style({
    width: '48px',
    marginRight: 13
})

export const avatar = style({
    width: '48px',
    height: '48px',
    borderRadius: '50%'
})

export const rightSide = style({
    flex: 1
})

export const title = style({
    fontSize: '16px',
    color: '#333333',
    letterSpacing: 0,
    lineHeight: '22px',
    fontWeight: 'bold'
})

export const personNumb = style({
    fontSize: '14px',
    color: '#999999',
    letterSpacing: 0,
    textAlign: 'justify',
    lineHeight: '20px',
    margin: '5px 0'
})

export const desc = style({
    'fontSize': '14px',
    'color': '#666666',
    'letterSpacing': 0,
    'textAlign': 'justify',
    'lineHeight': '22px',
    'display': '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 2,
    'overflow': 'hidden'
})



// WEBPACK FOOTER //
// ./src/views/SearchResult/MoreChannel/MoreChannel.style.ts